module.exports = __webpack_public_path__ + "img/bq_zd.2093ac7b.png";